import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "pb-3",
  key: "postnummer"
}
const _hoisted_2 = { key: "familyMemberCount_outer" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  key: "familyMemberCountLabel",
  class: "input__label",
  textContent: 'Antal personer i husstanden'
}, null, -1)
const _hoisted_4 = {
  key: "familyMemberCount_info_box",
  class: "highlights fill mb-4 mt-4"
}
const _hoisted_5 = { class: "text-left" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { key: "chooseAge" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "pb-3 pt-3 text-left",
  key: "chooseAgeLabel"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Er du ældste person i husstanden?")
], -1)
const _hoisted_9 = {
  key: 0,
  class: "text-left"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg ja eller nej'
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "button-container text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddressSearchComponent = _resolveComponent("AddressSearchComponent")!
  const _component_SelectModalComponent = _resolveComponent("SelectModalComponent")!
  const _component_RadioComponent = _resolveComponent("RadioComponent")!
  const _component_InputFieldComponent = _resolveComponent("InputFieldComponent")!
  const _component_ExistingABProductsComponent = _resolveComponent("ExistingABProductsComponent")!
  const _component_ButtonTapComponent = _resolveComponent("ButtonTapComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_TransitionGroup, { name: "slide-simple" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_AddressSearchComponent, {
            label: "Postnummer by",
            autocompleteId: "zipCode",
            placeholder: "F.eks 8000 Århus C",
            isOnlyZipSearch: true,
            defaultValue: _ctx.zipCodeDisplay,
            isValid: _ctx.model.personInfo.zipCode !== undefined,
            readonlyValue: _ctx.readonlyZip,
            visibleError: !_ctx.model.pristineStep.get(_ctx.card.name),
            onAddressSearch: _ctx.zipSearch
          }, null, 8, ["defaultValue", "isValid", "readonlyValue", "visibleError", "onAddressSearch"])
        ]),
        (_ctx.model.personInfo.zipCode && _ctx.model.personInfo.zipName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_SelectModalComponent, {
                key: "familyMemberCount",
                id: "familyMemberCount",
                name: "familyMemberCount",
                preSelect: _ctx.model.personInfo.familyMemberCount,
                innerData: _ctx.familyMemberList,
                selected: _ctx.model.personInfo.familyMemberCount !== undefined,
                placeholder: "Vælg antal personer i husstand",
                visibleError: !_ctx.model.pristineStep.get(_ctx.card.name),
                errorMsgOverride: "Vælg hvor mange personer der er i din husstand",
                readonlyValue: _ctx.readonlyFamilyMemberCount,
                "onSelectModalComponent:selected": _ctx.familyMemberSelected
              }, null, 8, ["preSelect", "innerData", "selected", "visibleError", "readonlyValue", "onSelectModalComponent:selected"]),
              _withDirectives(_createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", {
                    innerHTML: _ctx.cms.familyMemberInfo
                  }, null, 8, _hoisted_6)
                ])
              ], 512), [
                [_vShow, _ctx.cms.familyMemberInfo && !_ctx.readonlyFamilyMemberCount]
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showChooseAge && _ctx.model.personInfo.zipCode && _ctx.model.personInfo.familyMemberCount)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jaNejArray, (item, inx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([inx + 1 === _ctx.jaNejArray.length ? 'pb-3' : 'pb-2']),
                  key: 'chooseAge' + inx
                }, [
                  _createVNode(_component_RadioComponent, {
                    name: "chooseAge",
                    id: 'chooseAge' + item.value,
                    inputValue: item.value,
                    preSelect: _ctx.model.personInfo.isOldestInHousehold,
                    change: _ctx.model.personInfo.isOldestInHousehold === item.value,
                    trackingLabel: 'Almbrand kunde' + item.value,
                    onRadioComponent: _ctx.chooseAge
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.displayValue), 1)
                    ]),
                    _: 2
                  }, 1032, ["id", "inputValue", "preSelect", "change", "trackingLabel", "onRadioComponent"])
                ], 2))
              }), 128)),
              (!_ctx.model.pristineStep.get(_ctx.card.name) && !_ctx.model.personInfo.isOldestInHousehold)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_TransitionGroup, { name: "slide-simple" }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_InputFieldComponent, {
          class: "text-left pb-3",
          key: "customerAge",
          id: "customerAge",
          name: "customerAge",
          placeholder: "F.eks. 42 ",
          label: "Din alder",
          readonlyValue: _ctx.readonlyAge,
          validateOnLoad: !_ctx.model.pristineStep.get(_ctx.card.name),
          visibleError: !_ctx.model.pristineStep.get(_ctx.card.name),
          innerData: _ctx.model.personInfo,
          required: _ctx.model.personInfo.isOldestInHousehold === 'ja'
        }, null, 8, ["readonlyValue", "validateOnLoad", "visibleError", "innerData", "required"]), [
          [_vShow, 
					_ctx.model.personInfo.isOldestInHousehold === 'ja' &&
					_ctx.model.personInfo.zipCode &&
					_ctx.model.personInfo.zipName &&
					!_ctx.readonlyAge
				]
        ]),
        _withDirectives(_createVNode(_component_InputFieldComponent, {
          class: "text-left pb-3",
          key: "oldestInHouseholdAge",
          id: "oldestInHouseholdAge",
          name: "oldestInHouseholdAge",
          placeholder: "F.eks. 55 ",
          label: "Ældste i husstandens alder",
          validateOnLoad: !_ctx.model.pristineStep.get(_ctx.card.name),
          visibleError: !_ctx.model.pristineStep.get(_ctx.card.name),
          innerData: _ctx.model.personInfo,
          required: _ctx.model.personInfo.isOldestInHousehold === 'nej'
        }, null, 8, ["validateOnLoad", "visibleError", "innerData", "required"]), [
          [_vShow, 
					_ctx.model.personInfo.isOldestInHousehold === 'nej' &&
					_ctx.model.personInfo.zipCode &&
					_ctx.model.personInfo.zipName
				]
        ]),
        (_ctx.showExistingProducts)
          ? (_openBlock(), _createBlock(_component_ExistingABProductsComponent, {
              key: "ExistingABProductsComponent",
              class: "pt-3",
              card: _ctx.card
            }, null, 8, ["card"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_ButtonTapComponent, {
        class: _normalizeClass([_ctx.card.buttonStyle, 'mt-3', { 'btn-disabled': !_ctx.isValid }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nextStep())),
        textContent: _toDisplayString(_ctx.card.linkText),
        "data-gtm": _ctx.cms.dataGtm,
        "data-gtm-click-text": _ctx.card.routePath
      }, null, 8, ["class", "textContent", "data-gtm", "data-gtm-click-text"])
    ])
  ]))
}